import BillingsPlanEntryRelatedCargoTaxiRequest from "../../../../../api/raily/billings/plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.request";
import BillingsPlanEntryRelatedCargoTaxiParams from "./billings-plan-entry-related-cargo-taxi-params";

const create = (
  params: BillingsPlanEntryRelatedCargoTaxiParams,
): BillingsPlanEntryRelatedCargoTaxiRequest => {
  return {
    planEntryId: params.planEntryUuid,
  };
};

const billingsPlanEntryRelatedCargoTaxiParamsFactory = {
  create,
};

export default billingsPlanEntryRelatedCargoTaxiParamsFactory;
